import { render, staticRenderFns } from "./previewDialog.vue?vue&type=template&id=5179fecc&scoped=true"
import script from "./previewDialog.vue?vue&type=script&lang=js"
export * from "./previewDialog.vue?vue&type=script&lang=js"
import style0 from "./previewDialog.vue?vue&type=style&index=0&id=5179fecc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5179fecc",
  null
  
)

export default component.exports